import { render } from "./BookingComponent.vue?vue&type=template&id=03217164&scoped=true"
import script from "./BookingComponent.vue?vue&type=script&lang=js"
export * from "./BookingComponent.vue?vue&type=script&lang=js"

import "./BookingComponent.vue?vue&type=style&index=0&id=03217164&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03217164"]])

export default __exports__